package com.narbase.narnic.trial.medico

import com.narbase.bos.common.data.AppColors
import com.narbase.bos.common.medico.MedicoBalsamOnePageRef
import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.percent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.drawable.Color
import com.narbase.narnic.trial.common.addCrossDocumentMessagingHandler
import com.narbase.narnic.trial.common.headerShadowOnScroll
import com.narbase.narnic.trial.sections.testimonials.TestimonialsSection
import com.narbase.narnic.trial.utils.translations.Language
import com.narbase.narnic.trial.utils.translations.StorageManager
import com.narbase.narnic.trial.utils.translations.localized
import com.narbase.narnic.trial.utils.verticalFiller
import kotlinx.browser.window
import org.w3c.dom.asList

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2022/01/24.
 */
object MedicoLandingPageHydrate {
    fun hydrate(ref: MedicoBalsamOnePageRef) {
        StorageManager.language = if (ref.isArabic != null) Language.Ar else Language.En

        ref.medicoTabsRefView?.mount(
            TabsSection(
                "/public/img/balsam-medico.png",
                listOf(
                    emrTabContent,
                    schedulingTabContent,
                    reportsTabContent,
                    financeTabContent
                ),
                "linear-gradient(90deg, #E6F6F6a7 0%, #BDEEEEa7 50%, #E2F4F4a7 100%)"
            )
        )
        ref.testimonialsRefView?.mount(TestimonialsSection())

        headerShadowOnScroll(ref.headerView)
        hydrateMigrationAnimation(ref.curvesRoot)
        hydrateLandingPageMainVideo(ref.mainVideoHolder)
        addCrossDocumentMessagingHandler()
    }

    private fun hydrateMigrationAnimation(curvesRoot: View?) {
        curvesRoot ?: return
//        console.log("curvesRoot.element.getElementsByTagName(svg)")
//        console.log(curvesRoot.element.getElementsByTagName("svg"))
        val list = curvesRoot.element.getElementsByClassName("migration-curve").asList()

        val migrationItems = curvesRoot.element.getElementsByClassName("migration-item").asList()
        console.log(migrationItems)

        list.forEachIndexed { curveIndex, element ->

            (1..4).forEach { migrationIconIndex ->
                val speedFactor = 3.5
                val numberOfIcons = 4
                window.setTimeout({
                    val original = migrationItems[migrationIconIndex]
                    val item = original.cloneNode(deep = true)
                    original.parentElement?.appendChild(item)
                    item.asDynamic().style.opacity = "1"
                    MigrationAnimation(numberOfIcons * 1000 * speedFactor, 0, element, item).start()
                }, ((curveIndex + migrationIconIndex) * 1000 * speedFactor).toInt())
            }

        }
    }
    private fun hydrateLandingPageMainVideo(mainVideoHolder: View?) {
        mainVideoHolder?.apply {
            verticalFiller(64)
            textView {
                text = "See it in action".localized()
                style {
                    fontWeight = "600"
                    fontSize = 24.px
                    color = AppColors.narnicVeryDarkColor
                    textAlign = TextAlign.Center
                    textTransform = "uppercase"
                }
            }
            verticalFiller(16)
            textView {
                text = "See how it works in 2 minutes and 45 seconds".localized()
                style {
                    fontWeight = "300"
                    fontSize = 16.px
                    color = AppColors.narnicVeryDarkColor
                    textAlign = TextAlign.Center
//                    textTransform = "uppercase"
                }
            }
            verticalFiller(32)

            horizontalLayout {
                style {
                    width = matchParent
                    alignItems = Alignment.Center
                    justifyContent = JustifyContent.Center
                    padding = 16.px
                }
                verticalLayout {
                    style {
                        width = matchParent
                        maxWidth = 1200.px
                        position = "relative"
                        overflow = "hidden"
                        borderRadius = 8.px
                        boxShadow = "0px 0px 10px 1px rgba(0,0,0,0.1)"
                    }
                    val videoRoot = this

                    imageView {
                        style {
                            width = matchParent
                            objectFit = "contain"
//                            mediumScreen {
//                                height = 200.px
//                            }
                        }
                        element.src = "/public/img/MedicoVideoThumbnail.webp"
                    }
                    verticalLayout {
                        style {
                            width = 100.percent
                            position = "absolute"
                            top = 0.px
                            bottom = 0.px
                            left = 0.px
                            right = 0.px
                            cursor = "pointer"
                            backgroundColor = Color.transparent
                            alignItems = Alignment.Center
                            justifyContent = JustifyContent.Center
                            hover {
                                backgroundColor = Color(0, 0, 0, 0.1)
                            }
                        }
                        onClick = {
                            videoRoot.apply {
                                clearAllChildren()
                                video {
                                    style {
                                        width = 100.percent
                                    }
//                                    attributes["preload"] = "auto"
//                                    attributes["muted"] = true
//                                    attributes["loop"] = true
//                                    attributes["playsinline"] = true
//                                    attributes["webkit-playsinline"] = true
//                                    attributes["x5-playsinline"] = true

                                    element.setAttribute("controls", "true")
                                    element.setAttribute("autoplay", "true")
                                    element.setAttribute("type", "video/mp4")
                                    source {
                                        element.setAttribute("src", "/public/img/HomepageProject.mp4")
                                        element.setAttribute("type", "video/mp4")
                                    }

                                }
                            }
                        }
                        imageView {
                            style {
                                width = 20.percent
                                objectFit = "contain"
                            }
                            element.src = "/public/img/play_button.webp"
                        }


                    }
                }
            }

        }
    }

//    private fun View.getMigrationIcon(index: Int): View {
//        val imageWidth = 36
//        element.getElementsByClassName("migration-item")
////        return imageView {
////            style {
////                width = imageWidth.px
////                position = "absolute"
////                left = (-imageWidth / 2).px
////                top = (-imageWidth / 2).px
////            }
////            element.src = "/public/img/medico/migratable_$index.png"
////        }
//
//    }


    private val emrTabContent = FeatureTabContentDs(
        "Electronic Medical Record",
        "Powerful and flexible\n Electronic Medical Record",
        listOf("Autocomplete for input fields", "Customizable patient history and visit notes forms", "Voice notes"),
        "/public/img/emr.webp"
    )
    private val schedulingTabContent = FeatureTabContentDs(
        "Scheduling",
        "Scheduling,\nDone right!", listOf(
            "Appointments reminders to minimize patients no-show.",
            "Access your schedule anytime, anywhere.",
            "SMS to patients when appointment is booked",
            "Allow your patients to book appointmetns online.",
        ), "/public/img/scheduling.webp"
    )
    private val reportsTabContent = FeatureTabContentDs(
        "Dashboard & Reports",
        "Detailed reports,\nClearer image", listOf(
            "Intuitive dashboards, to get insights at a glance.",
            "Dive deeper with detailed finance and performance reports",
            "Review your staff performance with performance reports."
        ), "/public/img/dashboard.webp"
    )
    private val financeTabContent = FeatureTabContentDs(
        "Finance",
        "Better finance tracking\nThe life line of your practice", listOf(
            "Simplify your accounting, track everything.",
            "Generate insurance reports",
            "Manage expenses, staff payments, revenue share, and more.",
            "Print bills with your clinic logo."
        ), "/public/img/finance.png"
    )
}